import {
	BaseEidosType,
	DeviceGroup,
	DeviceRPi,
	EidosDeviceGroup,
	EidosFirmware,
	ProjectorPowerState,
} from "../../entries/Device"

export function interpretProjectorPowerState(eidos: BaseEidosType) {
	const powerBlock = eidos.projector?.state
	const powerState = eidos.projector_power?.state

	if (!powerBlock) return powerState

	const unknownStates = ["UNKNOWN", "UNDEFINED"]
	if (!unknownStates.includes(powerBlock.actual)) return powerBlock.actual
	if (!unknownStates.includes(powerBlock.expected)) return powerBlock.expected
	return powerBlock.desired
}

export class ProjectorPowerListener {
	device: DeviceRPi | DeviceGroup
	children: Array<DeviceRPi> = []

	powerState: ProjectorPowerState = $state("UNDEFINED")

	constructor(device: DeviceRPi | DeviceGroup) {
		this.device = device

		if (device instanceof DeviceGroup) {
			this.children = device.getChildDevices()
			this.children.forEach((d) => d.addUpdateListener(() => this.onEidosUpdate(device.eidos)))
		}

		this.device.addUpdateListener((dev) => this.onEidosUpdate(dev.eidos))
	}

	isGroup(): this is { device: DeviceGroup } {
		return this.device instanceof DeviceGroup
	}

	onEidosUpdate = (eidos: EidosFirmware | EidosDeviceGroup) => {
		if (this.isGroup()) {
			const childrenStates = this.children.map((dev) => interpretProjectorPowerState(dev.eidos))

			// if some are off, but some are on, show unknown
			// if some are on or off, but some are powering on, show warming up
			// if some are on or off, but some are powering off, show cooling off
			// if all are on show on
			// if all are off show off

			this.powerState = ProjectorPowerListener.parseGroupStates(childrenStates)
		} else {
			this.powerState = interpretProjectorPowerState(eidos)
		}

		console.warn(`Eidos update for ${this.device.name}, resulted in ${this.powerState}`)
	}

	static parseGroupStates(states: ProjectorPowerState[]): ProjectorPowerState {
		if (states.some((s) => s === "POWERING_ON" || s === "WARMING_UP")) {
			return "WARMING_UP"
		}

		if (states.some((s) => s === "POWERING_OFF" || s === "COOLING_DOWN")) {
			return "COOLING_DOWN"
		}

		const allOn = states.every((s) => s === "ON")
		if (allOn) return "ON"

		const allOff = states.every((s) => s === "OFF")
		if (allOff) return "OFF"

		return "PARTIAL" // fallback for weird cases
	}
}
